export const demoFlow = 'ab-testing-sign-up-demo-flows'
export const demoFlowVariant = {
  test: 'test',
  control: 'control',
}
